<template>
  <a
    v-if="element === 'a'"
    :href="link"
    :key="`hotel-menu-${text}`"
    class="hotel-nav--button"
    @mouseenter="showTooltip = true"
    @mouseleave="showTooltip = false"
  >
    <Icon :icon="icon" />

    <transition name="fade">
      <Tooltip v-show="showTooltip" :text="text" minWidth="0" nowrap />
    </transition>
  </a>

  <router-link
    v-else
    :to="link"
    :key="`hotel-menu-${text}`"
    class="hotel-nav--button"
    @mouseenter.native="showTooltip = true"
    @mouseleave.native="showTooltip = false"
  >
    <Icon :icon="icon" />

    <transition name="fade">
      <Tooltip v-show="showTooltip" :text="text" minWidth="0" nowrap />
    </transition>
  </router-link>
</template>

<script>
/** ================================================
 * LINK DO MENU DE NAVEGAÇÃO INTERNA DO HOTEL
 * ================================================= */
import Tooltip from '@/components/_base/elements/Tooltip'

export default {
  name: 'HotelNavLink',
  components: {
    Tooltip
  },
  props: {
    /** Elemento HTML do link */
    element: {
      type: String,
      default: 'a'
    },
    /** Link de direcionamento */
    link: {
      type: String,
      default: null
    },
    /** Texto da tooltip */
    text: {
      type: String,
      default: ''
    },
    /** Ícone do link */
    icon: {
      type: String,
      default: 'home'
    }
  },
  data() {
    return {
      showTooltip: false
    }
  },
  computed: {
    /** Retorna o evento adequado para o elemento passado */
    getEnterEventModifiers() {
      let mouseEvent = 'mouseenter.native'

      if (this.element === 'a') {
        mouseEvent = 'mouseenter'
      }

      return mouseEvent
    },
    /** Retorna o evento adequado para o this.elemento passado */
    getLeaveEventModifiers() {
      let mouseEvent = 'mouseleave.native'

      if (this.element === 'a') {
        mouseEvent = 'mouseleave'
      }

      return mouseEvent
    }
  }
}
</script>

<style lang="scss" scoped>
.hotel-nav {
  &--button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 66px;
    height: 66px;
    position: relative;

    background-color: $white;
    color: $gray-darker;
    border: 1px solid $gray-mid;
    border-radius: 12px;
    cursor: pointer;
    transition: color $color-anim linear, background-color $color-anim linear,
      box-shadow $color-anim linear;

    @include box-shadow(4px 4px 15px rgba(0, 0, 0, 0.1));

    .icon {
      width: auto;
      height: 50%;
    }

    & + & {
      margin-left: 8px;
    }

    &:hover {
      color: $gray-dark;
      background-color: $gray-lightest;
      @include box-shadow(4px 4px 15px rgba(0, 0, 0, 0.15));
    }
  }
}
</style>
